import {EntityModel} from "@fedeltapointofsale/data-client";
import {LicenseData} from "./license.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class LicenseEntityModel extends EntityModel<LicenseData> {
    constructor(injector: Injector) {
        super(injector, LicenseData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
